(function () {
  'use strict';

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function labelText(block) {
    var label = block.querySelector('.lbx-option-label');
    return normalize(label ? label.textContent : '');
  }

  function optionValues(block) {
    return Array.prototype.slice.call(block.querySelectorAll('[data-lbx-option-button]'))
      .map(function (button) { return normalize(button.getAttribute('data-lbx-option-value') || button.textContent); })
      .join(' ');
  }

  function hasAny(text, words) {
    return words.some(function (word) { return text.indexOf(word) !== -1; });
  }

  function roleForBlock(block) {
    var label = labelText(block);
    var values = optionValues(block);
    var all = label + ' ' + values;

    if (hasAny(label, ['color', 'colour', 'farbe', 'couleur', 'colore', 'cor', 'kleur']) ||
        hasAny(values, ['braun', 'brown', 'marron', 'marron', 'blanco', 'weiss', 'white', 'blau', 'blue', 'azul', 'schwarz', 'black', 'negro', 'grun', 'green', 'verde', 'grau', 'grey', 'gray', 'gris', 'orange', 'naranja', 'morado', 'morada', 'violeta', 'purple', 'lavender', 'lavanda', 'lila', 'elderberry', 'rosa', 'pink', 'cobre', 'copper', 'bronce', 'bronze', 'dorado', 'gold', 'titanio', 'titanium', 'petrol', 'teal', 'turquesa', 'moss', 'musgo', 'sage', 'salvia', 'argile', 'khaki', 'champagne', 'champan', 'champán'])) {
      return 'color';
    }

    if (hasAny(label, ['talla', 'size', 'grande', 'groesse', 'grosse', 'grosz', 'rahmengrosse', 'rahmengroesse', 'rahmengrosze', 'rahmen grosse', 'taille', 'tamanho', 'maat']) ||
        /(^|\s)(xxs|xs|s|m|l|xl|xxl)(\s|$)/.test(values)) {
      return 'size';
    }

    if (hasAny(label, ['bateria', 'battery', 'batterie', 'akku', 'accu', 'autonomia', 'autonomy', 'reichweite', 'capacidad', 'range']) ||
        /(^|\s)([3456789][0-9]{2})(\s|$|w|wh)/.test(values)) {
      return 'battery';
    }

    return '';
  }

  var colorMap = [
    { keys: ['elderberry', 'aubergine', 'berenjena'], color: '#5b2f5f' },
    { keys: ['lavender', 'lavanda', 'lila', 'lilac'], color: '#8b6fc8' },
    { keys: ['purple', 'purpura', 'purpura', 'púrpura', 'violeta', 'violet', 'morado', 'morada'], color: '#6f4aa2' },
    { keys: ['pink', 'rosa', 'rose'], color: '#d75b8c' },
    { keys: ['petrol', 'teal', 'turquoise', 'turquesa', 'aqua'], color: '#0f6f73' },
    { keys: ['navy', 'marine', 'marino', 'azul marino', 'dunkelblau'], color: '#172554' },
    { keys: ['blau', 'blue', 'azul', 'bleu', 'blu'], color: '#1d65d8' },
    { keys: ['moss', 'musgo', 'sage', 'salvia', 'argile', 'khaki'], color: '#6f7c55' },
    { keys: ['grun', 'gruen', 'green', 'verde', 'vert', 'olive', 'oliva'], color: '#3f6f4b' },
    { keys: ['burgundy', 'granate', 'burdeos', 'wine'], color: '#6f1d2a' },
    { keys: ['rot', 'red', 'rojo', 'roja', 'rouge', 'rosso'], color: '#b91c1c' },
    { keys: ['orange', 'naranja', 'arancione'], color: '#f97316' },
    { keys: ['gelb', 'yellow', 'amarillo', 'amarilla'], color: '#f3c735' },
    { keys: ['champagne', 'champan', 'champán'], color: '#d8c3a5' },
    { keys: ['beige', 'sand', 'arena', 'crema', 'cream', 'sable'], color: '#d8c3a5' },
    { keys: ['gold', 'dorado', 'oro'], color: '#c8a24a' },
    { keys: ['bronze', 'bronce'], color: '#9a6b34' },
    { keys: ['copper', 'cobre'], color: '#b87333' },
    { keys: ['brown', 'braun', 'marron', 'marrón', 'brun', 'cafe', 'café', 'chocolate'], color: '#8b5a34' },
    { keys: ['titanium', 'titanio'], color: '#9a958d' },
    { keys: ['silver', 'plata'], color: '#c8ccd2' },
    { keys: ['basalt', 'basalto', 'graphite', 'grafito', 'anthracite', 'antracita'], color: '#2b2d31' },
    { keys: ['grau', 'gray', 'grey', 'gris', 'grigio'], color: '#8f949a' },
    { keys: ['weiss', 'white', 'blanco', 'blanca', 'blanc', 'bianco'], color: '#f7f7f2' },
    { keys: ['schwarz', 'black', 'negro', 'negra', 'noir', 'nero'], color: '#15171c' }
  ];

  function colorForValue(value) {
    var n = normalize(value);
    for (var i = 0; i < colorMap.length; i += 1) {
      for (var j = 0; j < colorMap[i].keys.length; j += 1) {
        if (n.indexOf(colorMap[i].keys[j]) !== -1) return colorMap[i].color;
      }
    }
    return '';
  }

  function locale() {
    var lang = normalize(document.documentElement.lang || '');
    var path = normalize(location.pathname || '');
    if (lang.indexOf('de') === 0 || path.indexOf('de ') === 0 || path.indexOf('de eu') === 0) return 'de';
    if (lang.indexOf('fr') === 0 || path.indexOf('fr ') === 0) return 'fr';
    if (lang.indexOf('en') === 0 || path.indexOf('en ') === 0) return 'en';
    if (lang.indexOf('pt') === 0 || path.indexOf('pt ') === 0) return 'pt';
    return 'es';
  }

  function sizeText() {
    var l = locale();
    if (l === 'de') return 'Welche Größe brauchst du?';
    if (l === 'fr') return 'Quelle taille vous faut-il ?';
    if (l === 'en') return 'What size do you need?';
    if (l === 'pt') return 'Qual é o teu tamanho?';
    return '¿Cuál es tu talla?';
  }


  function renderSizeGuideButton(button) {
    if (!button) return;
    var text = sizeText();
    button.innerHTML = '<span class="lbx-size-guide-link-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4 16.5 16.5 4 20 7.5 7.5 20 4 16.5Z"></path><path d="M8 16 6.8 14.8"></path><path d="M10.5 13.5 9.3 12.3"></path><path d="M13 11 11.8 9.8"></path><path d="M15.5 8.5 14.3 7.3"></path></svg></span><span>' + text + '</span>';
  }

  function applyColor(block) {
    block.classList.add('lbx-v29-color-role');
    Array.prototype.slice.call(block.querySelectorAll('[data-lbx-option-button]')).forEach(function (button) {
      var value = button.getAttribute('data-lbx-option-value') || button.textContent;
      button.classList.add('lbx-v29-color-button');
      var swatch = colorForValue(value);
      if (swatch) {
        button.style.setProperty('--lbx-v29-swatch', swatch);
        button.style.setProperty('--lbx-v30-swatch', swatch);
        button.style.setProperty('--lbx-swatch', swatch);
      }
      button.setAttribute('title', value.trim());
      button.setAttribute('aria-label', value.trim());
    });
  }


  function canonicalizeSizeGuide(block) {
    var label = block && block.querySelector('.lbx-size-option-label, .lbx-option-label');
    if (!label) return;
    var buttons = Array.prototype.slice.call(block.querySelectorAll('button[data-lbx-size-guide-open], button.lbx-size-guide-link, button.lbx-v29-size-guide-link, button.lbx-v30-size-guide-link'));
    var keep = buttons.filter(function (button) { return label.contains(button); })[0] || buttons[0];
    if (!keep) return;
    keep.type = 'button';
    keep.classList.add('lbx-size-guide-link', 'lbx-v29-size-guide-link');
    keep.setAttribute('data-lbx-size-guide-open', '');
    renderSizeGuideButton(keep);
    if (keep.parentElement !== label) label.appendChild(keep);
    buttons.forEach(function (button) { if (button !== keep && block.contains(button)) button.remove(); });
  }

  function applySize(block) {
    block.classList.add('lbx-v29-size-role');
    var label = block.querySelector('.lbx-option-label');
    if (!label) return;
    if (!block.querySelector('[data-lbx-size-guide-open], .lbx-size-guide-link')) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'lbx-size-guide-link lbx-v29-size-guide-link';
      button.setAttribute('data-lbx-size-guide-open', '');
      renderSizeGuideButton(button);
      label.appendChild(button);
    }
    canonicalizeSizeGuide(block);
  }

  function applyBattery(block) {
    block.classList.add('lbx-v29-battery-role');
    Array.prototype.slice.call(block.querySelectorAll('[data-lbx-option-button]')).forEach(function (button) {
      var strong = button.querySelector('strong');
      if (strong && /^\d+$/.test(strong.textContent.trim())) strong.textContent = strong.textContent.trim() + ' W';
    });
  }

  function apply(root) {
    root = root || document;
    Array.prototype.slice.call(root.querySelectorAll('[id^="lbx-product-"] .lbx-option-block')).forEach(function (block) {
      if (block.getAttribute('data-lbx-v29-role-applied') === '1') return;
      var role = roleForBlock(block);
      if (!role) return;
      block.setAttribute('data-lbx-v29-role-applied', '1');
      block.setAttribute('data-lbx-v29-role', role);
      if (role === 'color') applyColor(block);
      if (role === 'size') applySize(block);
      if (role === 'battery') applyBattery(block);
    });
  }

  function boot() {
    apply(document);
    setTimeout(function () { apply(document); }, 250);
    setTimeout(function () { apply(document); }, 1000);
    /* v908: observar solo la ficha de producto. Observar todo documentElement
       generaba trabajo innecesario y podía mantener la página en carga. */
    Array.prototype.slice.call(document.querySelectorAll('[id^="lbx-product-"]')).forEach(function (root) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          Array.prototype.slice.call(mutation.addedNodes || []).forEach(function (node) {
            if (node && node.nodeType === 1) apply(node);
          });
        });
      });
      observer.observe(root, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
